import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  findAllRolesDTO,
  createRoleAndReturnRoleDTO,
  deleteRole,
  updateRole,
  findAllActions,
  deleteErrorRole,
  findAllRolesPageble,
} from '../../actions/role';
import RoleTable from '../Role/RoleTable';
import { setMessage } from '../../utils';
import withTranslations from '../../utils/HighOrderComponent';
import ErrorHandler from '../Reusable/ErrorHandler';
import LoadingIndicator from '../Reusable/LoadingIndicator';
import {
  numberOfItemsPerPage,
  rowsPerPageOptions,
} from '../../constants/globals.js';
import { TablePagination } from '@material-ui/core';
import { changePaginationTextToSerbian } from '../../utils';

class RoleList extends Component {
  constructor() {
    super();
    this.state = {
      activePage: 0,
      numberOfItemsPerPage: numberOfItemsPerPage,
      roles: [
        { roleName: 'Admin' },
        { roleName: 'Admin2' },
        { roleName: 'Korisnik' },
      ],
      modalIsOpened: false,
    };
  }
  componentDidMount() {
    this.props.findAllRolesPageble(0, this.state.numberOfItemsPerPage);
    this.props.findAllActions();
  }

  handlePreviewClose = () => {
    this.props.deleteErrorRole();
  };

  handlePageChange = (event, value) => {
    this.setState({
      activePage: value,
    });
    this.props.findAllRolesPageble(value, this.state.numberOfItemsPerPage);
  };

  handleChangeRowsPerPage = (event, value) => {
    this.props.findAllRolesPageble(0, event.target.value);

    this.setState({
      numberOfItemsPerPage: event.target.value,
      activePage: 0,
    });
  };

  isModalOpened = (show) => {
    this.setState({ modalIsOpened: show ? true : false });
  };

  render() {
    const {
        isLoadingNeeded,
        role,
        t,
        deleteErrorRole,
        deleteRole,
        updateRole,
        createRoleAndReturnRoleDTO,
      } = this.props || {},
      { roleDTOList, error, totalElements, actionList } = role || {};

    if (isLoadingNeeded) {
      return <LoadingIndicator />;
    }

    return (
      <div className="wrapper-fade-in content-min-height mb-5 mt-2">
        {!this.state.modalIsOpened && (
          <ErrorHandler error={error} deleteError={deleteErrorRole} />
        )}
        <div className="container">
          <RoleTable
            roleList={roleDTOList}
            createRoleAndReturnRoleDTO={createRoleAndReturnRoleDTO}
            deleteError={deleteErrorRole}
            deleteRole={deleteRole}
            updateRole={updateRole}
            actionList={actionList}
            error={error}
            isModalOpened={this.isModalOpened}
          />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <TablePagination
              component="div"
              count={Number(totalElements)}
              page={this.state.activePage}
              onPageChange={this.handlePageChange.bind(this)}
              rowsPerPageOptions={rowsPerPageOptions}
              onRowsPerPageChange={this.handleChangeRowsPerPage.bind(this)}
              rowsPerPage={this.state.numberOfItemsPerPage}
              labelRowsPerPage={t.rowPerPage}
              labelDisplayedRows={(obj) =>
                changePaginationTextToSerbian(obj, t.of)
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.role,
  isLoadingNeeded: state.role.loading,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllRolesPageble: (pageNumber, pageSize) => {
      dispatch(findAllRolesPageble(pageNumber, pageSize));
    },
    findAllRolesDTO: () => {
      dispatch(findAllRolesDTO());
    },
    createRoleAndReturnRoleDTO: (role, callback) => {
      dispatch(createRoleAndReturnRoleDTO(role, callback));
    },
    deleteRole: (id) => {
      dispatch(deleteRole(id));
    },
    updateRole: (id, callback) => {
      dispatch(updateRole(id, callback));
    },
    findAllActions: () => {
      dispatch(findAllActions());
    },
    deleteErrorRole: () => {
      dispatch(deleteErrorRole());
    },
    setMessage: (msg, tagId, msgId) => {
      dispatch(setMessage(msg, tagId, msgId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(RoleList, 'RoleList'));
